var _defs, _path, _rect, _rect2, _circle, _path2, _path3, _polygon, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _path5, _path6, _path7, _path8, _path9, _polygon2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _g2, _path22, _path23, _rect8, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _circle2, _path32, _path33, _path34, _path35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:#273139;}.cls-11,.cls-2{fill:#fff;}.cls-3{fill:#ebecf0;}.cls-4{fill:#a9adb7;}.cls-5{stroke:#fff;}.cls-11,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;stroke-width:0.75px;}.cls-6{fill:#92c7fc;}.cls-11,.cls-6,.cls-7{stroke:#273139;}.cls-7{fill:none;}.cls-8{fill:#f2f5f7;}.cls-9{opacity:0.47;}.cls-10{fill:#68b2f9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "start messaging-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.31,98.67s-16-9.63-11.49-21.43c2-4.35,10.77-10.77,19.46-4.46,3.52-2.69,16.47-3.62,16.26,14C189.36,93.59,173.31,98.67,173.31,98.67Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 263.28,
    y: 255.1,
    width: 32.09,
    height: 7.66
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265.56,
    y: 223.11,
    width: 27.64,
    height: 31.99
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "SVGID",
    className: "cls-3",
    cx: 279.44,
    cy: 172.69,
    r: 21.43,
    transform: "matrix(0.32, -0.95, 0.95, 0.32, 27.24, 383.18)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M293.41,255.41h-28V222.9h28ZM265.87,255H293V223.32H265.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M295.58,263h-32.5v-8h32.5Zm-32-.41h31.68v-7.15H263.59Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "279.64 222.28 279.54 223.11 279.23 193.6 279.64 193.6 279.64 222.28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M287.41,192.78a20.71,20.71,0,0,1-8,1.45,21.39,21.39,0,0,1-15.22-6.32,21.59,21.59,0,1,1,36.86-15.22h0a21.4,21.4,0,0,1-6.31,15.22A22.77,22.77,0,0,1,287.41,192.78Zm-15.74-39.86a21.2,21.2,0,0,0-13.46,19.67,21.23,21.23,0,1,0,42.45,0h0a21.24,21.24,0,0,0-21.12-21.23A24.37,24.37,0,0,0,271.67,152.92Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 279.23,
    y: 151.26,
    width: 0.41,
    height: 42.76
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 270.24,
    y: 155.9,
    width: 0.41,
    height: 21.74,
    transform: "translate(-20.77 293.86) rotate(-55.24)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 277.26,
    y: 166.69,
    width: 21.74,
    height: 0.41,
    transform: "translate(-43.16 200.39) rotate(-35.85)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 272.17,
    y: 152.8,
    width: 0.41,
    height: 17.08,
    transform: "translate(-16.64 290.53) rotate(-54.73)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 268.25,
    y: 168.88,
    width: 0.41,
    height: 24.23,
    transform: "translate(-22.26 323.52) rotate(-60.1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M206.65,186.57c.41-1.14.83-2.28,1.14-3.32a52.81,52.81,0,0,0,1.86-6.93c.21-.94.31-2,.52-2.9v-.31c0-.52.1-.94.1-1.45a14.69,14.69,0,0,0-.2-1.66,1.16,1.16,0,0,1,0-1c0-.1-.11-.2-.11-.31s-.1-.2-.2-.31a9.11,9.11,0,0,1-3.63-9.42c-21.64.83-83.24,4.45-84.38,18.12-1.45,16.57,3.21,90.18,3.21,90.18l4.46-.83,8.8-70.82s44.41-3,68.22-8.38A3.61,3.61,0,0,0,206.65,186.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M188.12,160.89s-39.24,50.21-35.82,56.94,52.69,60,52.69,60l6-3.62s-32.3-56-32.82-56.84,40.27-25.89,38-47.42C212.76,137.18,192.67,160.37,188.12,160.89Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.35,268.56h-4.66l-12.63,9,11.7-1.45,2.27-3s.83,3.21,1.35,3a20.6,20.6,0,0,1,3.62,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.81,278.09l13.77-9.84,5.08.11,1.86,8.17h-.41a18.1,18.1,0,0,0-3.42,0h-.41c-.42-.2-.83-1.44-1.25-2.58l-2,2.58Zm14-9.22-11.39,8.18,10.25-1.24,2.59-3.52.21.62a10,10,0,0,0,1,2.8,14.61,14.61,0,0,1,3.11,0L130,268.87Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.31,276.33H132a17.51,17.51,0,0,0-3.52,0h-.31c-.41-.21-.93-1.66-1.24-2.69l-2.07,2.69h-.1L112,277.88l13.46-9.63,5,.11Zm-3.83-.52c.62-.1,2.28,0,3.21,0l-1.55-7h-4.35l-11.7,8.39,10.67-1.35,2.48-3.42.1.52a7.34,7.34,0,0,0,1.14,2.9Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "212.34 277.47 206.55 279.02 198.68 288.03 208.82 285.23 209.96 281.71 212.66 284.09 216.07 283.16 212.34 277.47"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.75,288.65l8.69-9.94,6.11-1.76,4,6.31-3.94,1.14-2.48-2.17-1,3.1Zm9-9.32-7,8,8.8-2.48,1.25-3.73,3,2.59,2.79-.73-3.31-5.07Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.38,283.26l-3.83,1L210,282.13l-1,3.2-11.08,3.11,8.49-9.63,6-1.65Zm-3.62.52,2.9-.83-3.42-5.28-5.49,1.56-7.24,8.28,9.11-2.59,1.14-3.62Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.47,86.45c-7.35-.41-14.7,1.14-20.71,5.28-8.07,5.59-12.83,15.12-21.22,20.19-7.76,4.76-17.7,5-26.4,2.38s-16.46-7.66-23.71-13.15a55.54,55.54,0,0,0-6.52-4.45c-.93-.52-2.38-1.45-3.42-.93s-1.34,2.17-1.14,3.31a10.36,10.36,0,0,0,1.87,3.31c18,21.54,48.76,31.48,76,24.64a53.15,53.15,0,0,1,8.28,34,65.58,65.58,0,0,0,31.58,3.42A166.36,166.36,0,0,0,208.72,110c8-1.24,15.53,4.25,20.4,10.67,10.35,13.45,13.46,30.95,16,47.72,1.56-.2,3.21-.31,4.77-.51-.42-15.43-2.07-31.17-8-45.35S225.39,95.35,211,89.56A36.54,36.54,0,0,0,198.47,86.45Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M250.75,169.17a5,5,0,0,1,1.21,2.62c.2,1.56-.39,3.38-1.1,3.46-.35.05-.77-.31-.92-.44a2,2,0,0,1-.53-.67,2.26,2.26,0,0,1-.52,1.14.84.84,0,0,1-.83.31c-.41-.1-.72-.72-1-1.76a3.24,3.24,0,0,1-1.45,2,.8.8,0,0,1-.93,0c-.94-.62-.63-3.73-.21-6.21"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.32,51.87l-24.85.31a4.85,4.85,0,0,0-4.77,4.87L62,76.61a4.83,4.83,0,0,0,4.86,4.77l17.29-.21,7.25,7.45V81.07h.31a4.84,4.84,0,0,0,4.76-4.87l-.31-19.57A4.77,4.77,0,0,0,91.32,51.87Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.94,89.76l-8-8.07-17.08.2a4.65,4.65,0,0,1-2.07-.41h0a4.71,4.71,0,0,1-1.76-1.14,5.68,5.68,0,0,1-1.66-3.73l-.31-19.56a5.33,5.33,0,0,1,5.28-5.39l24.85-.31a4.91,4.91,0,0,1,3.73,1.56,5.66,5.66,0,0,1,1.66,3.72l.31,19.57a5.33,5.33,0,0,1-5,5.38Zm-7.56-9.11L91,87.38V80.55h.73a4.06,4.06,0,0,0,3-1.35A4.36,4.36,0,0,0,96,76.1l-.31-19.57a4,4,0,0,0-1.34-3,4.87,4.87,0,0,0-3.11-1.25l-24.85.31a4.29,4.29,0,0,0-4.24,4.35l.31,19.57a4.06,4.06,0,0,0,1.35,3,4.35,4.35,0,0,0,3.1,1.25Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.48,60.77,70.71,61a.67.67,0,0,1-.62-.62h0a.67.67,0,0,1,.62-.62l16.77-.21a.67.67,0,0,1,.63.62h0A.67.67,0,0,1,87.48,60.77Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.3,61.19a.83.83,0,0,1-.52-.83,1,1,0,0,1,.83-.93l16.77-.21a1.35,1.35,0,0,1,.62.21.86.86,0,0,1,.31.62,1.5,1.5,0,0,1-.2.62.75.75,0,0,1-.63.31l-16.77.21C70.61,61.29,70.4,61.19,70.3,61.19Zm17.29-1.45h0L70.71,60a.4.4,0,0,0-.31.1.39.39,0,0,0-.1.31.44.44,0,0,0,.41.41l16.77-.2a.38.38,0,0,0,.32-.11v-.31c0-.1,0-.2-.21-.41C87.69,59.84,87.59,59.84,87.59,59.74Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.59,67l-16.77.2a.68.68,0,0,1-.63-.62h0a.68.68,0,0,1,.63-.62l16.77-.21a.67.67,0,0,1,.62.62h0A.6.6,0,0,1,87.59,67Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.4,67.4a.82.82,0,0,1-.52-.83,1.52,1.52,0,0,1,.21-.62.73.73,0,0,1,.62-.31l16.77-.1a1.54,1.54,0,0,1,.63.2.94.94,0,0,1,.31.62,1.57,1.57,0,0,1-.21.63.74.74,0,0,1-.62.31l-16.77.2C70.61,67.5,70.51,67.5,70.4,67.4Zm17.29-1.35h0l-16.87.21a.37.37,0,0,0-.42.41.45.45,0,0,0,.42.42l16.77-.21a.39.39,0,0,0,.31-.1.4.4,0,0,0,.1-.31.38.38,0,0,0-.1-.31A.31.31,0,0,0,87.69,66.05Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.59,73.3l-16.77.21a.68.68,0,0,1-.63-.62h0a.68.68,0,0,1,.63-.62l16.77-.21a.67.67,0,0,1,.62.62h0A.6.6,0,0,1,87.59,73.3Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.51,73.72a.82.82,0,0,1-.52-.83,1.46,1.46,0,0,1,.2-.62.75.75,0,0,1,.63-.31l16.77-.21a1.39,1.39,0,0,1,.62.21.86.86,0,0,1,.31.62,1,1,0,0,1-.83.93l-16.87.31C70.71,73.82,70.61,73.72,70.51,73.72ZM87.8,72.37h0l-16.88.21a.36.36,0,0,0-.41.41.43.43,0,0,0,.41.41l16.77-.2a.38.38,0,0,0,.42-.42.37.37,0,0,0-.11-.31A.31.31,0,0,0,87.8,72.37Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M212.85,164.21a167.47,167.47,0,0,0,.41-20.61,169.63,169.63,0,0,0-4.87-33.87c5-.91,27.77-1.54,37.19,57.89a5.43,5.43,0,0,1,2.48,0s-7.14-75.79-45.55-62.53a55.7,55.7,0,0,1-12.91,58,67.22,67.22,0,0,0,10.88,1.54A66.44,66.44,0,0,0,212.85,164.21Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M96.73,101.35a75.42,75.42,0,0,0,19.74,13.16c23.4,10.69,45.75,6.12,54.19,3.92.56,1.73,1.13,3.46,1.69,5.2l1,3.11a77,77,0,0,1-63.09-12.56,73.9,73.9,0,0,1-7.85-6.57A67.89,67.89,0,0,1,96.73,101.35Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.15,134.7l-24.43,31h24.43Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.92,165.86l-.1-.21h-.31V134.49h24.95v31.27h-.21C91.83,165.65,77.65,165.65,76.92,165.86ZM77,135v30.43c1.14-.1,5.69-.2,23.91-.1V135.11L77,135Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 39.13,
    y: 165.34,
    width: 67.92,
    height: 4.87
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.36,170.52H38.93v-5.39h68.43ZM39.45,170h67.39v-4.35H39.45Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.83,165.44H45.14V135.63h5.69Zm-5.17-.51h4.66V136.14H45.66Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.05,165.44h-5.7V135.63h5.7Zm-5.28-.51h4.65V136.14H51.77Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.36,165.44H57.67V135.63h5.69Zm-5.18-.51h4.66V136.14H58.18Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.77,93a8.32,8.32,0,0,0,3.71-6.89,10.32,10.32,0,0,1-5.34,4.25C175.08,91.79,175.77,93,175.77,93Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M95.85,94.19a17.14,17.14,0,0,0-6.15.25c-1.24.28-4.07.93-4.24,2.25-.06.48.21,1.21.67,1.31a1,1,0,0,0,.81-.34,1.78,1.78,0,0,0,.23,1.44,1.55,1.55,0,0,0,.81.53c1.47.44,3.79-.94,4.06-1.1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M198.47,86.45c-7.35-.41-14.7,1.14-20.71,5.28-8.07,5.59-12.83,15.12-21.22,20.19-7.76,4.76-17.7,5-26.4,2.38s-16.46-7.66-23.71-13.15a55.54,55.54,0,0,0-6.52-4.45c-.93-.52-2.38-1.45-3.42-.93s-1.34,2.17-1.14,3.31a10.36,10.36,0,0,0,1.87,3.31c18,21.54,48.76,31.48,76,24.64a53.15,53.15,0,0,1,8.28,34,65.58,65.58,0,0,0,31.58,3.42A166.36,166.36,0,0,0,208.72,110c8-1.24,15.53,4.25,20.4,10.67,10.35,13.45,13.46,30.95,16,47.72,1.56-.2,3.21-.31,4.77-.51-.42-15.43-2.07-31.17-8-45.35S225.39,95.35,211,89.56A36.54,36.54,0,0,0,198.47,86.45Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M181.08,95.46h0a3.9,3.9,0,0,1-5.18-1.66l-4-8a3.9,3.9,0,0,1,1.66-5.18h0a3.9,3.9,0,0,1,5.18,1.66l4,8A3.78,3.78,0,0,1,181.08,95.46Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 172.07,
    cy: 82.31,
    r: 8.28
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.66,72.47c-.72.83-.41-3.41-4.34-2-.32.1-1.76-3.84-1.87-4.25A5.53,5.53,0,0,1,175,61.5a5.18,5.18,0,0,1,8.8.1C186.05,65.43,182.94,69.57,180.66,72.47Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.1,90.69a13.55,13.55,0,0,1-2-12.11c2-.83,7.56,3.42,11.7,1.45,1.25,3,3.52,10,5.7,10.15,1.86-1.66,2.79-11.7,2.79-11.7l-7.56-4.25s-15.73-5.8-15.84,10C165.55,90.38,167.1,90.69,167.1,90.69Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.45,77l2.18,5.07A2.81,2.81,0,0,0,177.45,77Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.75,93.07a8.24,8.24,0,0,0,3.83-6.72,10.17,10.17,0,0,1-5.37,4.07C175.09,91.89,175.75,93.07,175.75,93.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartChat);
export default __webpack_public_path__ + "static/media/start_chat.dcd2d18fce92465ca860eaebf5c4d373.svg";
export { ForwardRef as ReactComponent };